import React from 'react';
import {
	NavItem,
	NavLink,
	Row,
	Col,
	UncontrolledDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem
} from 'reactstrap';
import { exitAdmin, checkLogin } from '../scripts/SessionHelper';
import './NavMenu.css';

export function NavMenu() {
		const validate = checkLogin();

		const exitAdminPanel = exitAdmin;

		return (
			<div className='navigation-bar navigation-bar-desktop'>
				<Row className='no-gutters'>
					<Col xs='auto' className='col menu-item'>
						<a className='navigation-bar-link' href='/'>
							<NavItem>
								Главная
							</NavItem>
						</a>
					</Col>
					<Col xs='auto' className='col menu-item'>
						<a className='navigation-bar-link' href='/catalog'>
							<NavItem>
								Каталог
							</NavItem>
						</a>
					</Col>
					<Col xs='auto' className='col menu-item'>
						<a className='navigation-bar-link' href='/works'>
							<NavItem>
								Наши работы
							</NavItem>
						</a>
					</Col>
					<Col xs='auto' className='col menu-item'>
						<a className='navigation-bar-link' href='/comments'>
							<NavItem>
								Отзывы
							</NavItem>
						</a>
					</Col>
					<Col xs='auto' className='col menu-item'>
						<a className='navigation-bar-link' href='/about'>
							<NavItem>
								О компании
							</NavItem>
						</a>
					</Col>
					<Col xs='auto' className='col menu-item'>
						<a className='navigation-bar-link' href='/contacts'>
							<NavItem>
								Контакты
							</NavItem>
						</a>
					</Col>
					{validate && <Col xs='auto' className='col menu-item'>
						<div className='navigation-bar-link'>
							<UncontrolledDropdown nav inNavbar>
								<DropdownToggle nav caret className='nav-item'>
									Панель администратора
								</DropdownToggle>
								<DropdownMenu right>
									<DropdownItem>
										<NavLink href='/uploadItem'>Загрузить товар</NavLink>
									</DropdownItem>
									<DropdownItem>
										<NavLink href='/adminComments'>Управление отзывами</NavLink>
									</DropdownItem>
									<DropdownItem>
										<NavLink href='/actions'>Управление акциями</NavLink>
									</DropdownItem>
									<DropdownItem>
										<NavLink href='/changePassword'>Сменить пароль</NavLink>
									</DropdownItem>
									<DropdownItem divider />
									<DropdownItem onClick={exitAdminPanel}>
										Выход
									</DropdownItem>
								</DropdownMenu>
							</UncontrolledDropdown>
						</div>
					</Col>}
				</Row>
			</div>
		);
}